import type { ReactElement } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Ctext } from '../Ctext';
export enum InitialAuthDividerVariant {
    AuthOptions = 'authOptions',
    Footer = 'footer'
}
interface InitialAuthDividerProps {
    variant: InitialAuthDividerVariant;
}
export function InitialAuthDivider({ variant }: InitialAuthDividerProps): ReactElement {
    if (variant === InitialAuthDividerVariant.Footer) {
        return (
        <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                marginTop: '23px',
            }}>
          <div style={{
                flex: 1,
                height: '1px',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
            }}/>
        </div>
      );
    }
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            marginTop: '32px',
            marginBottom: '23px',
        }}>
        <div style={{
            flex: 1,
            height: '1px',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
        }}/>
        <Ctext size={16} weight={FontWeight.Regular} color={ColorType.White} opacity={1} style={{ padding: '0 16px' }}>
          OR
        </Ctext>
        <div style={{
            flex: 1,
            height: '1px',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
        }}/>
      </div>
    );
}
